/* RESPONSIBLE TEAM: team-automation-foundations */
import ContentEditorController from 'embercom/controllers/apps/app/content/edit';

export default ContentEditorController;
